import { render } from "./ChangeLog.vue?vue&type=template&id=be9ec6da&scoped=true"
import script from "./ChangeLog.vue?vue&type=script&lang=js"
export * from "./ChangeLog.vue?vue&type=script&lang=js"

import "./ChangeLog.vue?vue&type=style&index=0&id=be9ec6da&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9ec6da"]])

export default __exports__